import { createContext, useContext } from 'react';

import type { PageConfigComponent as PageConfigComponentTrackingData, Recommender } from '@coursera/event-pulse-types';

type PageConfigComponentMetadataContextType = {
  id: string;
  index: number;
  name?: string;
  recommender?: Recommender;
};

const PageConfigComponentMetadataContext = createContext<PageConfigComponentMetadataContextType | undefined>(undefined);

export const usePageConfigComponentMetadata = () => {
  return useContext(PageConfigComponentMetadataContext);
};
export const usePageConfigComponentTrackingData = (): PageConfigComponentTrackingData | undefined => {
  const context = useContext(PageConfigComponentMetadataContext);

  if (!context) {
    return undefined;
  }

  return { id: context.id, name: context.name ?? 'unknown', index: context.index, recommender: context.recommender };
};

export default PageConfigComponentMetadataContext;
